<template>
  <div class="profile_wrapper most_profile">
    <div
      class="profile_header_wrapper custom_card"
      :style="`background: var(--mainColor-2)`"
    >
      <vue-particles
        color="#fff"
        :particleOpacity="0.7"
        :particlesNumber="180"
        shapeType="circle"
        :particleSize="4"
        linesColor="#fff"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.3"
        :linesDistance="100"
        :moveSpeed="4"
        :hoverEffect="true"
        :clickEffect="true"
        hoverMode="repulse"
        clickMode="push"
      ></vue-particles>

      <div class="profile_header_data" v-if="data.userInfo">
        <!-- <div class="avatar_wrapper">
          <img
            v-if="data.userInfo.images.length"
            :src="data.userInfo.images[0].image"
            width="100"
            height="100"
            alt="Avatar"
          />
        </div> -->

        <div class="avatar_wrapper">
          <upload-image-direct
            @inputChanged="uplodeImg_1"
            v-if="data.userInfo.images.length"
            model="places"
            :data_src="data.userInfo.images[0].image"
            placeHolder="الصورة"
          ></upload-image-direct>
        </div>

        <div class="name_wrapper">
          <h3>
            <router-link :to="'/users/show/' + data.userInfo.id">
              {{ data.userInfo.full_name }}
            </router-link>
          </h3>
        </div>
      </div>

      <div
        v-else
        class="text-center text-white mt-4 fs-4 position-absolute top-50 w-100"
      >
        لا يوجد بيانات
      </div>
    </div>
    <transition name="fadeInUp" mode="out-in" v-if="!data.userInfo">
      <MainLoader />
    </transition>

    <personal-data v-else :userInfo="data.userInfo" @get_item="getData" />
    <!-- <router-view :userInfo="data.userInfo">
    </router-view> -->

    <Breadcrumb
      :search_route="`/googlePlace/${$route.params.id}/add`"
      search_title="إضافه وجبة"
      icon="fa-plus"
    />

    <main>
      <v-data-table
        class="thumb strip"
        :headers="headers"
        :items="rows"
        :custom-filter="helper_filterSearch"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Image -->
        <template v-slot:[`item.image`]="{ item }">
          <img @click="show_model_1" class="image" :src="item.image" />
        </template>

        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <span>{{ item.is_active == 1 ? "مُفعل" : "غير مُفعل" }}</span>
        </template>

        <template v-slot:[`item.is_ban`]="{ item }">
          <v-btn
            @click="toggleStatusModel(item)"
            :color="item.is_ban ? 'error' : 'success'"
            >{{ item.is_ban ? "محظور" : "غير محظور" }}</v-btn
          >
        </template>
        <!-- <template v-slot:[`item.fullname`]="{ item }">
            <span v-if="!item.fullname || item.fullname == ''">لا يوجد</span>
            <span>{{ item.fullname }}</span>
          </template> -->
        <!-- <template v-slot:[`item.phone`]="{ item }">
            <span v-if="!item.phone || item.phone == ''">لا يوجد</span>
            <span>{{ item.phone_code + item.phone }}</span>
          </template> -->
        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon>
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon>
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <h3 class="table-title title">
            الوجبات
            <span class="total">({{ rows.length }})</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  far fa-info-circle
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </h3>
          <!-- Delete dialog -->
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Add & Delete -->
          <v-row>
            <v-col cols="12" sm="8"></v-col>
          </v-row>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!-- Start Pagination -->
    <template>
      <div
        class="pagination_container text-center mb-5 d-flex justify-content-end"
      >
        <v-pagination
          color="primary"
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="5"
          @input="fetchData($event)"
        ></v-pagination>
      </div>
    </template>
    <!-- End Pagination -->
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PersonalData from "./children/PersonalData.vue";
export default {
  components: { PersonalData },
  props: ["id"],

  data() {
    return {
      data: {
        userInfo: null,
        loading: false,
        // ========== Data To Send
        image_preview: null,
        avatar: null,
      },
      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      rows: [],
      // ========== Main Loader
      loaderPage: false,
      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: false,
          },
          {
            text: "الصورة",
            align: "center",
            value: "image",
            sortable: false,
          },
          {
            text: "الاسم",
            value: "name",
            align: "center",
            sortable: false,
          },
          {
            text: "الوصف",
            value: "desc",
            align: "center",
            sortable: false,
          },
          {
            text: "مفعل؟",
            value: "is_active",
            align: "center",
            sortable: false,
          },
          {
            text: "تاريخ الإنشاء ",
            value: "created_at",
            align: "center",
            sortable: false,
          },
          // {
          //   text: "الدولة",
          //   value: "country.name",
          //   align: "center",
          // },
          // {
          //   text: "حالة الحظر",
          //   value: "is_ban",
          //   align: "center",
          // },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: false,
          },
          {
            text: "image",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Name", value: "fullname", align: "center" },
          { text: "Followers", value: "followers_count", align: "center" },
          { text: "Following", value: "followings_count", align: "center" },
          {
            text: "Active",
            value: "is_active",
            align: "center",
          },
          {
            text: "Permission",
            value: "role",
            align: "center",
          },
          {
            text: "control",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
    keyword() {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword;
      } else {
        return "";
      }
    },
  },
  methods: {
    getData() {
      this.data.loading = true;
      this.$axios({
        method: "GET",
        url: `show_place/${this.id}`,
        params: {
          page: this.paginations.current_page,
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.data.userInfo = res.data.place;
          this.data.userInfo.loading = false;
          this.rows = res.data.data;

          this.data.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.avatar = obj;
      this.submitData();
    },

    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.getData();
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    showItem(item) {
      this.$router.push({ path: `/googlePlace/${this.id}/show/${item.id}` });
    },
    editItem(item) {
      this.$router.push({ path: `/googlePlace/${this.id}/edit/${item.id}` });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `delete_multi_google_meals/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    submitData() {
      const submit_data = new FormData();
      if (this.data.avatar) {
        submit_data.append("image", this.data.avatar);
      }

      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `place/${this.id}/update_image`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/googlePlace/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.avatar_wrapper {
  overflow: hidden;
}
</style>
